import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppPage = _resolveComponent("AppPage")!
  const _component_MaintenancePage = _resolveComponent("MaintenancePage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isMaintenance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_AppPage)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isMaintenance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MaintenancePage)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}